import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/** Match IdCardTemplate design width so capture matches on-screen preview. */
export const ID_CARD_EXPORT_WIDTH_PX = 430;

/**
 * html2canvas defaults tuned for ID cards: sharp output, correct colors, CORS images.
 */
export function getIdCardHtml2CanvasOptions(): Parameters<typeof html2canvas>[1] {
  const scale = Math.min(3, Math.max(2, typeof window !== "undefined" ? window.devicePixelRatio || 2 : 2));
  return {
    scale,
    useCORS: true,
    allowTaint: true,
    backgroundColor: "#ffffff",
    logging: false,
  } as Parameters<typeof html2canvas>[1];
}

export async function captureIdCardElement(element: HTMLElement): Promise<HTMLCanvasElement> {
  return html2canvas(element, getIdCardHtml2CanvasOptions());
}

/**
 * Places the card on A4 without stretching — same aspect ratio as the modal / PNG export.
 */
export function addIdCardCanvasToPdf(
  pdf: InstanceType<typeof jsPDF>,
  canvas: HTMLCanvasElement,
  imgData: string,
  format: "JPEG" | "PNG",
  marginMm = 14
): void {
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const maxW = pageW - 2 * marginMm;
  const maxH = pageH - 2 * marginMm;

  const cw = canvas.width;
  const ch = canvas.height;
  if (cw <= 0 || ch <= 0) {
    pdf.addImage(imgData, format, marginMm, marginMm, maxW, maxH);
    return;
  }

  const ratio = cw / ch;
  let drawW = maxW;
  let drawH = drawW / ratio;
  if (drawH > maxH) {
    drawH = maxH;
    drawW = drawH * ratio;
  }

  const x = (pageW - drawW) / 2;
  const y = (pageH - drawH) / 2;
  pdf.addImage(imgData, format, x, y, drawW, drawH);
}
